const transfer = (res, page) => {
  if(res) {
    res.writeHead(302, {
      Location: page
    })
    res.end()
  }
}

export default transfer